var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCraftOven(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 473.359 923.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 366.78,
    y1: 306.98,
    x2: 366.78,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7b299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d8c1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Machnes_and_dividers"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "448.48 558.68 273.4 558.68 0 514.84 148.73 514.84 448.48 558.68",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.4,
    y: 558.68,
    width: 175.08,
    height: 10.69,
    fill: "#f2c2a0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.4 558.68 273.4 569.37 0 523.92 0 514.84 273.4 558.68",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "283.218 402.39 279.12 551.52 260.2 548.64 260.2 401.96 283.218 402.39",
    fill: "#877d70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.57,403.31v148.21c0,.51-.41,.93-.92,.93h-143.61c-.51,0-.92-.42-.92-.93v-148.21c0-.5,.41-.92,.92-.92h143.61c.51,0,.92,.42,.92,.92Z",
    fill: "#ddd3c5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288.643,
    y: 411.162,
    width: 116.104,
    height: 128.927,
    fill: "#c6bdae"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.748,
    y: 411.162,
    width: 10.923,
    height: 128.927,
    transform: "translate(820.418 951.252) rotate(180)",
    fill: "#877d70"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 339.025,
    cy: 456.896,
    r: 2.51,
    fill: "#763539"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.025,
    cy: 492.247,
    r: 2.51,
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.701,
    cy: 474.571,
    r: 2.51,
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.35,
    cy: 474.571,
    r: 2.51,
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.025,
    cy: 435.521,
    r: 2.51,
    fill: "#91726d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.025,
    cy: 514.27,
    r: 2.51,
    fill: "#93887f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.713,
    cy: 440.797,
    r: 2.51,
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.338,
    cy: 508.995,
    r: 2.51,
    fill: "#93887f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.125,
    cy: 455.208,
    r: 2.51,
    fill: "#4e3830"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.926,
    cy: 494.583,
    r: 2.51,
    fill: "#9e967d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.4,
    cy: 474.896,
    r: 2.51,
    fill: "#28100c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.651,
    cy: 474.896,
    r: 2.51,
    fill: "#91726d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.125,
    cy: 494.583,
    r: 2.51,
    fill: "#726e75"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.926,
    cy: 455.208,
    r: 2.51,
    fill: "#91726d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.713,
    cy: 508.995,
    r: 2.51,
    fill: "#93887f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.338,
    cy: 440.797,
    r: 2.51,
    fill: "#91726d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.025,
    cy: 492.247,
    r: 2.51,
    fill: "#382d2a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.701,
    cy: 474.571,
    r: 2.51,
    fill: "#28100c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.35,
    cy: 474.571,
    r: 2.51,
    fill: "#763539"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.863,
    cy: 459.264,
    r: 2.51,
    fill: "#28100c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.188,
    cy: 489.879,
    r: 2.51,
    fill: "#382d2a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.333,
    cy: 483.409,
    r: 2.51,
    fill: "#28100c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.718,
    cy: 465.733,
    r: 2.51,
    fill: "#763539"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.333,
    cy: 465.733,
    r: 2.51,
    fill: "#28100c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.718,
    cy: 483.409,
    r: 2.51,
    fill: "#a88c73"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.863,
    cy: 489.879,
    r: 2.51,
    fill: "#382d2a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.188,
    cy: 459.264,
    r: 2.51,
    fill: "#763539"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "255.236 0 255.236 923.77 45.016 835.31 45.016 37.01 255.236 0",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.449,
    width: 11.499,
    height: 923.77,
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.603,107.927h0c-1.389,.201-2.512-.438-2.512-1.427v-36.742c0-.988,1.124-1.987,2.512-2.23h0c1.392-.244,2.522,.362,2.522,1.354v36.884c0,.992-1.13,1.96-2.522,2.161Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.493,92.388v-7.044c0-1.962,2.224-3.92,4.977-4.375l4.271-.707c2.784-.461,5.049,.772,5.049,2.755v7.122c0,1.983-2.265,3.941-5.049,4.371l-4.271,.66c-2.754,.426-4.978-.821-4.978-2.782Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.308,104.791h0c-1.435,.207-2.596-.439-2.596-1.444v-37.352c0-1.005,1.161-2.023,2.596-2.275h0c1.438-.252,2.607,.36,2.607,1.369v37.499c0,1.009-1.168,1.995-2.607,2.203Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.96,89.011v-7.161c0-1.994,2.298-3.991,5.144-4.462l4.415-.731c2.877-.476,5.219,.771,5.219,2.787v7.241c0,2.016-2.341,4.013-5.219,4.457l-4.415,.682c-2.846,.44-5.144-.821-5.144-2.815Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.748,101.548h0c-1.484,.214-2.685-.44-2.685-1.462V62.103c0-1.022,1.201-2.061,2.685-2.321h0c1.487-.261,2.696,.359,2.696,1.384v38.135c0,1.026-1.208,2.032-2.696,2.247Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.15,85.521v-7.281c0-2.028,2.376-4.064,5.319-4.551l4.566-.755c2.976-.492,5.398,.769,5.398,2.82v7.364c0,2.051-2.422,4.087-5.398,4.547l-4.566,.706c-2.943,.455-5.319-.822-5.319-2.849Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.961,98.194h0c-1.536,.222-2.778-.441-2.778-1.48V58.077c0-1.039,1.242-2.1,2.778-2.369h0c1.539-.27,2.789,.356,2.789,1.4v38.793c0,1.044-1.25,2.07-2.789,2.293Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.099,81.912v-7.406c0-2.062,2.458-4.141,5.503-4.645l4.724-.782c3.079-.51,5.586,.767,5.586,2.853v7.492c0,2.086-2.506,4.165-5.586,4.641l-4.724,.73c-3.045,.471-5.503-.821-5.503-2.884Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M154.987,94.722h0c-1.59,.23-2.876-.442-2.876-1.499V53.911c0-1.058,1.286-2.141,2.876-2.42h0c1.594-.28,2.888,.354,2.888,1.416v39.474c0,1.062-1.295,2.11-2.888,2.34Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.848,78.177v-7.535c0-2.098,2.545-4.22,5.696-4.742l4.891-.809c3.189-.528,5.784,.764,5.784,2.887v7.624c0,2.123-2.595,4.245-5.784,4.738l-4.891,.756c-3.152,.487-5.697-.82-5.697-2.919Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.87,91.126h0c-1.647,.238-2.98-.442-2.98-1.518V49.597c0-1.076,1.333-2.183,2.98-2.472h0c1.651-.29,2.992,.351,2.992,1.432v40.18c0,1.081-1.341,2.151-2.992,2.389Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.44,74.309v-7.668c0-2.135,2.636-4.303,5.901-4.843l5.067-.838c3.304-.547,5.993,.76,5.993,2.921v7.761c0,2.161-2.689,4.329-5.993,4.839l-5.067,.783c-3.265,.505-5.901-.819-5.901-2.955Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M205.657,87.4h0c-1.707,.247-3.089-.442-3.089-1.538V45.126c0-1.096,1.381-2.227,3.089-2.526h0c1.712-.3,3.102,.348,3.102,1.448v40.911c0,1.101-1.39,2.194-3.102,2.441Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.918,70.302v-7.807c0-2.174,2.732-4.388,6.116-4.948l5.253-.869c3.425-.567,6.214,.756,6.214,2.956v7.902c0,2.201-2.788,4.415-6.213,4.945l-5.253,.812c-3.384,.523-6.116-.817-6.116-2.991Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.397,83.536h0c-1.771,.256-3.204-.442-3.204-1.558V40.49c0-1.116,1.433-2.272,3.204-2.583h0c1.775-.312,3.218,.344,3.218,1.465v41.669c0,1.121-1.442,2.238-3.218,2.495Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.334,66.147v-7.95c0-2.214,2.833-4.477,6.343-5.058l5.449-.902c3.553-.588,6.447,.75,6.447,2.992v8.049c0,2.241-2.893,4.506-6.446,5.055l-5.449,.842c-3.51,.543-6.344-.814-6.344-3.028Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.603,168.826h0c-1.389,.136-2.512-.556-2.512-1.544v-36.742c0-.988,1.124-1.934,2.512-2.113h0c1.392-.179,2.522,.48,2.522,1.472v36.884c0,.992-1.13,1.907-2.522,2.043Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.493,152.954v-7.044c0-1.962,2.224-3.816,4.977-4.143l4.271-.507c2.784-.331,5.049,1.008,5.049,2.991v7.122c0,1.983-2.265,3.835-5.049,4.135l-4.271,.461c-2.754,.297-4.978-1.053-4.978-3.015Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.308,166.704h0c-1.435,.14-2.596-.561-2.596-1.565v-37.352c0-1.005,1.161-1.969,2.596-2.154h0c1.438-.185,2.607,.482,2.607,1.491v37.499c0,1.009-1.168,1.941-2.607,2.081Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.96,150.581v-7.161c0-1.994,2.298-3.883,5.144-4.221l4.415-.524c2.877-.342,5.219,1.015,5.219,3.031v7.241c0,2.016-2.341,3.903-5.219,4.214l-4.415,.476c-2.846,.307-5.144-1.062-5.144-3.056Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.748,164.509h0c-1.484,.145-2.685-.566-2.685-1.588v-37.983c0-1.022,1.201-2.005,2.685-2.196h0c1.487-.192,2.696,.484,2.696,1.51v38.135c0,1.026-1.208,1.976-2.696,2.121Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.15,148.127v-7.281c0-2.028,2.376-3.953,5.319-4.303l4.566-.542c2.976-.353,5.398,1.021,5.398,3.072v7.364c0,2.051-2.422,3.974-5.398,4.295l-4.566,.492c-2.943,.317-5.319-1.07-5.319-3.098Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.96,162.239h0c-1.536,.15-2.778-.571-2.778-1.61v-38.636c0-1.039,1.242-2.042,2.778-2.24h0c1.539-.198,2.789,.487,2.789,1.53v38.793c0,1.044-1.25,2.012-2.789,2.162Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.099,145.589v-7.406c0-2.062,2.458-4.026,5.503-4.388l4.724-.561c3.079-.366,5.586,1.028,5.586,3.114v7.492c0,2.086-2.506,4.048-5.586,4.38l-4.724,.51c-3.045,.328-5.503-1.078-5.503-3.141Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M154.987,159.889h0c-1.59,.155-2.876-.576-2.876-1.634v-39.312c0-1.058,1.286-2.08,2.876-2.285h0c1.594-.205,2.888,.489,2.888,1.551v39.474c0,1.062-1.295,2.049-2.888,2.205Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.848,142.963v-7.535c0-2.098,2.545-4.101,5.696-4.476l4.891-.581c3.189-.379,5.784,1.034,5.784,3.157v7.624c0,2.123-2.595,4.124-5.784,4.468l-4.891,.528c-3.152,.34-5.697-1.087-5.697-3.185Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.87,157.456h0c-1.647,.161-2.98-.581-2.98-1.657v-40.011c0-1.076,1.333-2.12,2.98-2.333h0c1.651-.213,2.992,.491,2.992,1.572v40.18c0,1.081-1.341,2.088-2.992,2.25Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.44,140.244v-7.668c0-2.135,2.636-4.179,5.901-4.567l5.067-.602c3.304-.392,5.993,1.04,5.993,3.201v7.761c0,2.161-2.689,4.203-5.993,4.559l-5.067,.547c-3.265,.352-5.901-1.095-5.901-3.23Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M205.657,154.934h0c-1.707,.167-3.089-.586-3.089-1.682v-40.736c0-1.096,1.381-2.162,3.089-2.382h0c1.712-.22,3.102,.493,3.102,1.593v40.911c0,1.101-1.39,2.129-3.102,2.296Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.918,137.427v-7.807c0-2.174,2.732-4.261,6.116-4.663l5.253-.624c3.425-.407,6.214,1.046,6.214,3.247v7.902c0,2.201-2.788,4.285-6.213,4.654l-5.253,.567c-3.384,.365-6.116-1.103-6.116-3.277Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.397,152.318h0c-1.771,.173-3.204-.591-3.204-1.707v-41.488c0-1.116,1.433-2.205,3.204-2.433h0c1.775-.229,3.218,.494,3.218,1.615v41.669c0,1.121-1.442,2.171-3.218,2.344Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.334,134.506v-7.95c0-2.214,2.833-4.345,6.343-4.762l5.449-.647c3.553-.422,6.447,1.052,6.447,3.293v8.049c0,2.241-2.893,4.371-6.446,4.754l-5.449,.588c-3.51,.379-6.344-1.111-6.344-3.325Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.603,229.725h0c-1.389,.071-2.512-.673-2.512-1.661v-36.742c0-.988,1.124-1.882,2.512-1.996h0c1.392-.114,2.522,.597,2.522,1.59v36.884c0,.992-1.13,1.854-2.522,1.925Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.493,213.521v-7.044c0-1.962,2.224-3.712,4.977-3.91l4.271-.308c2.784-.201,5.049,1.244,5.049,3.227v7.122c0,1.983-2.265,3.729-5.049,3.899l-4.271,.261c-2.754,.168-4.978-1.286-4.978-3.247Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.308,228.616h0c-1.435,.073-2.596-.682-2.596-1.687v-37.352c0-1.005,1.161-1.915,2.596-2.032h0c1.438-.118,2.607,.604,2.607,1.613v37.499c0,1.009-1.168,1.886-2.607,1.96Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.96,212.15v-7.161c0-1.994,2.298-3.776,5.144-3.981l4.415-.318c2.877-.207,5.219,1.259,5.219,3.275v7.241c0,2.016-2.341,3.794-5.219,3.97l-4.415,.27c-2.846,.174-5.144-1.302-5.144-3.296Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.748,227.47h0c-1.484,.076-2.685-.691-2.685-1.713v-37.983c0-1.022,1.201-1.949,2.685-2.07h0c1.487-.122,2.696,.61,2.696,1.636v38.135c0,1.026-1.208,1.919-2.696,1.995Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.15,210.733v-7.281c0-2.028,2.376-3.842,5.319-4.054l4.566-.329c2.976-.214,5.398,1.273,5.398,3.324v7.364c0,2.051-2.422,3.861-5.398,4.043l-4.566,.279c-2.943,.18-5.319-1.318-5.319-3.346Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.96,226.284h0c-1.536,.078-2.778-.701-2.778-1.74v-38.636c0-1.039,1.242-1.984,2.778-2.11h0c1.539-.126,2.789,.617,2.789,1.661v38.793c0,1.044-1.25,1.953-2.789,2.032Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.099,209.267v-7.406c0-2.062,2.458-3.911,5.503-4.131l4.724-.34c3.079-.222,5.586,1.289,5.586,3.375v7.492c0,2.086-2.506,3.931-5.586,4.119l-4.724,.289c-3.045,.186-5.503-1.335-5.503-3.398Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M154.987,225.056h0c-1.59,.081-2.876-.71-2.876-1.768v-39.312c0-1.058,1.286-2.02,2.876-2.151h0c1.594-.131,2.888,.624,2.888,1.686v39.474c0,1.062-1.295,1.989-2.888,2.07Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.848,207.75v-7.535c0-2.098,2.545-3.982,5.696-4.21l4.891-.352c3.189-.23,5.784,1.304,5.784,3.427v7.624c0,2.123-2.595,4.003-5.784,4.198l-4.891,.299c-3.152,.193-5.697-1.353-5.697-3.451Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.87,223.785h0c-1.647,.084-2.98-.72-2.98-1.797v-40.011c0-1.076,1.333-2.058,2.98-2.193h0c1.651-.136,2.992,.631,2.992,1.712v40.18c0,1.081-1.341,2.026-2.992,2.11Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.44,206.18v-7.668c0-2.135,2.636-4.056,5.901-4.292l5.067-.365c3.304-.238,5.993,1.32,5.993,3.481v7.761c0,2.161-2.689,4.077-5.993,4.279l-5.067,.31c-3.265,.2-5.901-1.37-5.901-3.506Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M205.657,222.467h0c-1.707,.087-3.089-.731-3.089-1.826v-40.736c0-1.096,1.381-2.098,3.089-2.238h0c1.712-.14,3.102,.638,3.102,1.738v40.911c0,1.101-1.39,2.064-3.102,2.151Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.918,204.552v-7.807c0-2.174,2.732-4.133,6.116-4.377l5.253-.379c3.425-.247,6.214,1.336,6.214,3.537v7.902c0,2.201-2.788,4.155-6.213,4.364l-5.253,.321c-3.384,.207-6.116-1.388-6.116-3.562Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.397,221.101h0c-1.771,.09-3.204-.741-3.204-1.857v-41.488c0-1.116,1.433-2.138,3.204-2.284h0c1.775-.146,3.218,.645,3.218,1.766v41.669c0,1.121-1.442,2.103-3.218,2.194Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.334,202.865v-7.95c0-2.214,2.833-4.213,6.343-4.466l5.449-.393c3.553-.256,6.447,1.353,6.447,3.594v8.049c0,2.241-2.893,4.235-6.446,4.453l-5.449,.333c-3.51,.215-6.344-1.407-6.344-3.621Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.603,290.624h0c-1.389,.006-2.512-.79-2.512-1.779v-36.742c0-.988,1.124-1.829,2.512-1.878h0c1.392-.049,2.522,.715,2.522,1.707v36.884c0,.992-1.13,1.802-2.522,1.808Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.493,274.088v-7.044c0-1.962,2.224-3.608,4.977-3.678l4.271-.108c2.784-.071,5.049,1.48,5.049,3.463v7.122c0,1.983-2.265,3.623-5.049,3.664l-4.271,.062c-2.754,.04-4.978-1.518-4.978-3.48Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.308,290.529h0c-1.435,.006-2.596-.803-2.596-1.808v-37.352c0-1.005,1.161-1.86,2.596-1.911h0c1.438-.051,2.607,.726,2.607,1.734v37.499c0,1.009-1.168,1.832-2.607,1.838Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.96,273.719v-7.161c0-1.994,2.298-3.669,5.144-3.741l4.415-.112c2.877-.073,5.219,1.502,5.219,3.519v7.241c0,2.016-2.341,3.685-5.219,3.726l-4.415,.064c-2.846,.041-5.144-1.542-5.144-3.536Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.748,290.43h0c-1.484,.007-2.685-.817-2.685-1.838v-37.983c0-1.022,1.201-1.893,2.685-1.945h0c1.487-.053,2.696,.736,2.696,1.762v38.135c0,1.026-1.208,1.863-2.696,1.869Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.15,273.339v-7.281c0-2.028,2.376-3.731,5.319-3.806l4.566-.116c2.976-.075,5.398,1.526,5.398,3.576v7.364c0,2.051-2.422,3.748-5.398,3.791l-4.566,.066c-2.943,.043-5.319-1.567-5.319-3.595Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.96,290.328h0c-1.536,.007-2.778-.83-2.778-1.87v-38.636c0-1.039,1.242-1.926,2.778-1.98h0c1.539-.054,2.789,.747,2.789,1.791v38.793c0,1.044-1.25,1.895-2.789,1.902Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.099,272.945v-7.406c0-2.062,2.458-3.796,5.503-3.874l4.724-.12c3.079-.078,5.586,1.55,5.586,3.636v7.492c0,2.086-2.506,3.814-5.586,3.858l-4.724,.068c-3.045,.044-5.503-1.592-5.503-3.655Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M154.987,290.223h0c-1.59,.007-2.876-.845-2.876-1.902v-39.312c0-1.058,1.286-1.96,2.876-2.017h0c1.594-.056,2.888,.759,2.888,1.821v39.474c0,1.062-1.295,1.928-2.888,1.935Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.848,272.537v-7.535c0-2.098,2.545-3.864,5.696-3.943l4.891-.124c3.189-.081,5.784,1.574,5.784,3.697v7.624c0,2.123-2.595,3.881-5.784,3.927l-4.891,.071c-3.152,.046-5.697-1.619-5.697-3.717Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.87,290.114h0c-1.647,.007-2.98-.859-2.98-1.936v-40.011c0-1.076,1.333-1.996,2.98-2.054h0c1.651-.058,2.992,.77,2.992,1.851v40.18c0,1.081-1.341,1.963-2.992,1.97Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.439,272.115v-7.668c0-2.135,2.636-3.933,5.901-4.016l5.067-.128c3.304-.084,5.993,1.6,5.993,3.761v7.761c0,2.161-2.689,3.952-5.993,3.999l-5.067,.073c-3.265,.047-5.901-1.646-5.901-3.781Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M205.657,290.001h0c-1.707,.007-3.089-.875-3.089-1.971v-40.736c0-1.096,1.381-2.033,3.089-2.093h0c1.712-.061,3.102,.782,3.102,1.883v40.911c0,1.101-1.39,1.999-3.102,2.006Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.918,271.678v-7.807c0-2.174,2.732-4.005,6.116-4.091l5.253-.133c3.425-.087,6.214,1.626,6.214,3.827v7.902c0,2.201-2.788,4.025-6.213,4.074l-5.253,.076c-3.384,.049-6.116-1.674-6.116-3.848Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.397,289.883h0c-1.771,.008-3.204-.891-3.204-2.007v-41.488c0-1.116,1.433-2.071,3.204-2.134h0c1.775-.063,3.218,.795,3.218,1.916v41.669c0,1.121-1.442,2.036-3.218,2.044Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.334,271.224v-7.95c0-2.214,2.833-4.08,6.343-4.169l5.449-.138c3.553-.09,6.447,1.654,6.447,3.895v8.049c0,2.241-2.893,4.1-6.446,4.152l-5.449,.079c-3.51,.051-6.344-1.703-6.344-3.917Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.603,351.523h0c-1.389-.059-2.512-.908-2.512-1.896v-36.742c0-.988,1.124-1.777,2.512-1.761h0c1.392,.016,2.522,.833,2.522,1.825v36.884c0,.992-1.13,1.749-2.522,1.69Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.493,334.654v-7.044c0-1.962,2.224-3.504,4.977-3.445l4.271,.091c2.784,.059,5.049,1.716,5.049,3.699v7.122c0,1.983-2.265,3.518-5.049,3.428l-4.271-.138c-2.754-.089-4.978-1.751-4.978-3.712Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.308,352.441h0c-1.435-.061-2.596-.924-2.596-1.929v-37.352c0-1.005,1.161-1.806,2.596-1.79h0c1.438,.016,2.607,.847,2.607,1.856v37.499c0,1.009-1.168,1.777-2.607,1.716Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.96,335.289v-7.161c0-1.994,2.298-3.561,5.144-3.501l4.415,.094c2.877,.061,5.219,1.746,5.219,3.762v7.241c0,2.016-2.341,3.575-5.219,3.483l-4.415-.142c-2.846-.092-5.144-1.782-5.144-3.777Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.748,353.391h0c-1.484-.063-2.685-.942-2.685-1.964v-37.983c0-1.022,1.201-1.836,2.685-1.82h0c1.487,.017,2.696,.862,2.696,1.888v38.135c0,1.026-1.208,1.806-2.696,1.743Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.15,335.944v-7.281c0-2.028,2.376-3.62,5.319-3.558l4.566,.097c2.976,.064,5.398,1.778,5.398,3.828v7.364c0,2.051-2.422,3.635-5.398,3.539l-4.566-.147c-2.943-.095-5.319-1.815-5.319-3.843Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.96,354.373h0c-1.536-.065-2.778-.96-2.778-1.999v-38.636c0-1.039,1.242-1.868,2.778-1.85h0c1.539,.017,2.789,.878,2.789,1.921v38.793c0,1.044-1.25,1.837-2.789,1.772Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.099,336.622v-7.406c0-2.062,2.458-3.682,5.503-3.617l4.724,.101c3.079,.066,5.586,1.811,5.586,3.897v7.492c0,2.086-2.506,3.696-5.586,3.597l-4.724-.152c-3.045-.098-5.503-1.849-5.503-3.912Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M154.987,355.39h0c-1.59-.067-2.876-.979-2.876-2.037v-39.312c0-1.058,1.286-1.9,2.876-1.882h0c1.594,.018,2.888,.894,2.888,1.955v39.474c0,1.062-1.295,1.868-2.888,1.801Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.848,337.324v-7.535c0-2.098,2.545-3.745,5.696-3.677l4.891,.104c3.189,.068,5.784,1.845,5.784,3.968v7.624c0,2.123-2.595,3.76-5.784,3.657l-4.891-.158c-3.152-.102-5.697-1.885-5.697-3.983Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.87,356.443h0c-1.647-.07-2.98-.999-2.98-2.075v-40.011c0-1.076,1.333-1.934,2.98-1.915h0c1.651,.019,2.992,.91,2.992,1.991v40.18c0,1.081-1.341,1.9-2.992,1.83Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.439,338.05v-7.668c0-2.135,2.636-3.81,5.901-3.74l5.067,.108c3.304,.071,5.993,1.88,5.993,4.041v7.761c0,2.161-2.689,3.826-5.993,3.72l-5.067-.163c-3.265-.105-5.901-1.922-5.901-4.057Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M205.656,357.534h0c-1.707-.072-3.089-1.019-3.089-2.115v-40.736c0-1.096,1.381-1.969,3.089-1.949h0c1.712,.019,3.102,.927,3.102,2.028v40.911c0,1.101-1.39,1.934-3.102,1.861Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.918,338.803v-7.807c0-2.174,2.732-3.878,6.116-3.806l5.253,.112c3.425,.073,6.214,1.917,6.214,4.117v7.902c0,2.201-2.788,3.894-6.213,3.784l-5.253-.169c-3.384-.109-6.116-1.96-6.116-4.134Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.397,358.666h0c-1.771-.075-3.204-1.04-3.204-2.156v-41.488c0-1.116,1.433-2.005,3.204-1.984h0c1.775,.02,3.218,.945,3.218,2.066v41.669c0,1.121-1.442,1.969-3.218,1.893Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.334,339.583v-7.95c0-2.214,2.833-3.948,6.343-3.873l5.449,.116c3.553,.076,6.447,1.955,6.447,4.196v8.049c0,2.241-2.893,3.965-6.446,3.851l-5.449-.176c-3.51-.113-6.344-1.999-6.344-4.213Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.603,412.421h0c-1.389-.124-2.512-1.025-2.512-2.013v-36.742c0-.988,1.124-1.724,2.512-1.644h0c1.392,.081,2.522,.951,2.522,1.943v36.884c0,.992-1.13,1.696-2.522,1.572Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.493,395.221v-7.044c0-1.962,2.224-3.4,4.977-3.213l4.271,.291c2.784,.189,5.049,1.951,5.049,3.935v7.122c0,1.983-2.265,3.412-5.049,3.192l-4.271-.337c-2.754-.217-4.978-1.983-4.978-3.945Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.308,414.354h0c-1.435-.128-2.596-1.046-2.596-2.051v-37.352c0-1.005,1.161-1.752,2.596-1.669h0c1.438,.083,2.607,.969,2.607,1.978v37.499c0,1.009-1.168,1.723-2.607,1.594Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.96,396.858v-7.161c0-1.994,2.298-3.454,5.144-3.26l4.415,.3c2.877,.196,5.219,1.99,5.219,4.006v7.241c0,2.016-2.341,3.466-5.219,3.239l-4.415-.349c-2.846-.225-5.144-2.023-5.144-4.017Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.748,416.351h0c-1.484-.132-2.685-1.067-2.685-2.089v-37.983c0-1.022,1.201-1.78,2.685-1.694h0c1.487,.086,2.696,.988,2.696,2.014v38.135c0,1.026-1.208,1.75-2.696,1.618Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.15,398.55v-7.281c0-2.028,2.376-3.509,5.319-3.309l4.566,.311c2.976,.203,5.398,2.03,5.398,4.081v7.364c0,2.051-2.422,3.522-5.398,3.287l-4.566-.361c-2.943-.232-5.319-2.064-5.319-4.091Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.96,418.418h0c-1.536-.137-2.778-1.09-2.778-2.129v-38.636c0-1.039,1.242-1.81,2.778-1.721h0c1.539,.089,2.789,1.008,2.789,2.051v38.793c0,1.044-1.25,1.778-2.789,1.641Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.099,400.3v-7.406c0-2.062,2.458-3.567,5.503-3.36l4.724,.322c3.079,.21,5.586,2.071,5.586,4.158v7.492c0,2.086-2.506,3.579-5.586,3.336l-4.724-.373c-3.045-.24-5.503-2.106-5.503-4.169Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M154.986,420.557h0c-1.59-.142-2.876-1.113-2.876-2.171v-39.312c0-1.058,1.286-1.84,2.876-1.748h0c1.594,.092,2.888,1.028,2.888,2.09v39.474c0,1.062-1.295,1.807-2.888,1.666Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.848,402.111v-7.535c0-2.098,2.545-3.626,5.696-3.411l4.891,.333c3.189,.217,5.784,2.115,5.784,4.238v7.624c0,2.123-2.595,3.639-5.784,3.387l-4.891-.386c-3.152-.249-5.697-2.151-5.697-4.249Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.87,422.772h0c-1.647-.147-2.98-1.138-2.98-2.214v-40.011c0-1.076,1.333-1.872,2.98-1.776h0c1.651,.096,2.992,1.05,2.992,2.131v40.18c0,1.081-1.341,1.838-2.992,1.691Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.439,403.986v-7.668c0-2.135,2.636-3.687,5.901-3.465l5.067,.345c3.304,.225,5.993,2.16,5.993,4.321v7.761c0,2.161-2.689,3.7-5.993,3.44l-5.067-.4c-3.265-.258-5.901-2.197-5.901-4.333Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M205.656,425.067h0c-1.707-.152-3.089-1.163-3.089-2.259v-40.736c0-1.096,1.381-1.904,3.089-1.805h0c1.712,.099,3.102,1.072,3.102,2.173v40.911c0,1.101-1.39,1.869-3.102,1.717Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.918,405.928v-7.807c0-2.174,2.732-3.75,6.116-3.52l5.253,.357c3.425,.233,6.214,2.207,6.214,4.407v7.902c0,2.201-2.788,3.764-6.213,3.494l-5.253-.415c-3.384-.267-6.116-2.245-6.116-4.419Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.397,427.448h0c-1.771-.158-3.204-1.19-3.204-2.306v-41.488c0-1.116,1.433-1.938,3.204-1.835h0c1.775,.103,3.218,1.095,3.218,2.216v41.669c0,1.121-1.442,1.901-3.218,1.743Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.334,407.942v-7.95c0-2.214,2.833-3.816,6.343-3.577l5.449,.371c3.553,.242,6.447,2.256,6.447,4.497v8.049c0,2.241-2.893,3.83-6.446,3.549l-5.449-.43c-3.51-.277-6.344-2.296-6.344-4.51Z",
    fill: "#7f5640"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.202,488.782h0c-1.457-.208-2.638-1.156-2.638-2.118l-.004-35.743c0-.961,1.179-1.592,2.636-1.41h0c1.459,.183,2.643,1.112,2.643,2.076l.006,35.826c0,.964-1.184,1.577-2.643,1.369Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.726,471.572v-6.862c0-1.911,2.34-3.153,5.234-2.774l4.48,.587c2.913,.382,5.28,2.251,5.281,4.174l.002,6.908c0,1.924-2.366,3.159-5.28,2.759l-4.48-.614c-2.895-.397-5.236-2.267-5.236-4.178Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.823,492.01h0c-1.487-.212-2.691-1.171-2.691-2.143l-.014-36.099c0-.971,1.202-1.607,2.688-1.42h0c1.488,.187,2.696,1.127,2.696,2.1l.016,36.184c0,.974-1.207,1.591-2.696,1.378Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.193,474.618l-.002-6.93c0-1.93,2.386-3.181,5.338-2.794l4.569,.599c2.971,.389,5.387,2.28,5.388,4.223l.004,6.977c0,1.943-2.413,3.187-5.385,2.78l-4.57-.626c-2.952-.405-5.341-2.297-5.341-4.227Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.898,495.303h0c-1.517-.216-2.745-1.187-2.746-2.168l-.024-36.463c0-.98,1.226-1.621,2.742-1.431h0c1.518,.19,2.75,1.142,2.751,2.124l.026,36.549c0,.984-1.231,1.605-2.75,1.389Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.11,477.725l-.004-7c-.001-1.949,2.433-3.21,5.445-2.815l4.662,.611c3.031,.397,5.496,2.311,5.498,4.273l.006,7.047c.002,1.963-2.461,3.216-5.493,2.8l-4.662-.639c-3.012-.413-5.449-2.327-5.45-4.277Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.442,498.663h0c-1.547-.221-2.801-1.203-2.802-2.195l-.035-36.834c0-.99,1.251-1.636,2.797-1.442h0c1.549,.194,2.807,1.157,2.808,2.15l.037,36.922c0,.994-1.256,1.62-2.805,1.399Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.491,480.895l-.006-7.071c-.002-1.969,2.482-3.239,5.554-2.837l4.757,.623c3.093,.405,5.609,2.342,5.611,4.324l.008,7.119c.002,1.983-2.51,3.245-5.604,2.821l-4.758-.652c-3.073-.421-5.56-2.359-5.562-4.328Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M157.469,502.092h0c-1.579-.225-2.859-1.22-2.86-2.221l-.046-37.212c-.001-1.001,1.276-1.651,2.855-1.453h0c1.581,.198,2.865,1.172,2.866,2.175l.048,37.303c.001,1.004-1.281,1.635-2.863,1.409Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.349,484.13l-.008-7.144c-.002-1.989,2.532-3.269,5.668-2.858l4.855,.636c3.157,.414,5.725,2.373,5.728,4.376l.01,7.193c.003,2.003-2.561,3.275-5.719,2.843l-4.856-.666c-3.137-.43-5.675-2.391-5.677-4.38Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M181.993,505.591h0c-1.612-.23-2.919-1.237-2.92-2.249l-.057-37.599c-.002-1.011,1.302-1.667,2.913-1.465h0c1.614,.202,2.925,1.188,2.926,2.202l.06,37.691c.002,1.014-1.307,1.65-2.922,1.419Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7,487.431l-.011-7.218c-.003-2.01,2.583-3.3,5.784-2.88l4.956,.649c3.223,.422,5.845,2.406,5.849,4.43l.012,7.268c.003,2.024-2.614,3.306-5.837,2.864l-4.957-.679c-3.202-.439-5.793-2.423-5.796-4.434Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.032,509.164h0c-1.646-.235-2.981-1.254-2.982-2.277l-.069-37.993c-.002-1.022,1.329-1.683,2.974-1.476h0c1.648,.207,2.986,1.205,2.988,2.229l.072,38.088c.002,1.025-1.334,1.665-2.983,1.43Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.559,490.801l-.013-7.293c-.004-2.031,2.637-3.33,5.905-2.902l5.06,.663c3.291,.431,5.969,2.439,5.973,4.484l.014,7.345c.004,2.045-2.668,3.337-5.959,2.886l-5.061-.694c-3.269-.448-5.916-2.457-5.919-4.488Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.6,512.813h0c-1.681-.24-3.044-1.272-3.046-2.305l-.081-38.396c-.002-1.032,1.356-1.699,3.037-1.488h0c1.683,.211,3.05,1.221,3.052,2.256l.084,38.493c.002,1.036-1.362,1.681-3.046,1.441Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.943,494.243l-.015-7.37c-.004-2.052,2.691-3.362,6.029-2.925l5.168,.677c3.361,.44,6.097,2.474,6.101,4.541l.017,7.423c.005,2.067-2.723,3.369-6.085,2.908l-5.169-.709c-3.338-.458-6.042-2.492-6.046-4.545Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.21,548.049h0c-1.458-.246-2.639-1.226-2.64-2.19l-.004-35.793c0-.962,1.18-1.564,2.638-1.343h0c1.46,.221,2.644,1.183,2.645,2.147l.006,35.877c0,.966-1.185,1.548-2.645,1.302Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.729,530.621v-6.872c0-1.913,2.342-3.096,5.238-2.642l4.483,.704c2.915,.458,5.284,2.391,5.285,4.317l.002,6.917c0,1.926-2.368,3.102-5.284,2.626l-4.484-.731c-2.897-.473-5.24-2.406-5.24-4.32Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.847,551.87h0c-1.488-.251-2.692-1.243-2.693-2.216l-.014-36.151c0-.972,1.203-1.578,2.69-1.352h0c1.489,.226,2.698,1.198,2.698,2.173l.016,36.236c0,.975-1.208,1.562-2.698,1.31Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.212,534.255l-.002-6.94c0-1.932,2.388-3.124,5.342-2.66l4.573,.718c2.974,.467,5.391,2.424,5.392,4.369l.004,6.987c.001,1.946-2.415,3.129-5.389,2.644l-4.573-.746c-2.955-.482-5.345-2.439-5.345-4.372Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.94,555.767h0c-1.518-.256-2.747-1.26-2.748-2.243l-.024-36.515c0-.982,1.227-1.592,2.744-1.362h0c1.519,.23,2.752,1.215,2.753,2.199l.026,36.602c0,.985-1.232,1.576-2.752,1.319Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.146,537.961l-.004-7.01c-.001-1.952,2.435-3.151,5.449-2.678l4.665,.733c3.034,.476,5.5,2.457,5.502,4.422l.006,7.058c.002,1.966-2.463,3.157-5.497,2.662l-4.666-.761c-3.014-.492-5.453-2.472-5.454-4.425Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.501,559.743h0c-1.549-.261-2.803-1.278-2.804-2.271l-.035-36.887c0-.992,1.252-1.606,2.8-1.372h0c1.55,.235,2.809,1.231,2.81,2.226l.037,36.976c0,.995-1.257,1.589-2.808,1.328Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.544,541.743l-.006-7.081c-.002-1.972,2.484-3.179,5.559-2.696l4.76,.748c3.096,.486,5.613,2.491,5.615,4.476l.008,7.13c.002,1.986-2.512,3.185-5.608,2.68l-4.761-.777c-3.076-.502-5.564-2.506-5.566-4.479Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M157.546,563.801h0c-1.581-.267-2.861-1.296-2.863-2.299l-.046-37.267c-.001-1.002,1.277-1.621,2.857-1.381h0c1.582,.24,2.867,1.248,2.868,2.253l.048,37.358c.001,1.005-1.282,1.604-2.865,1.337Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.421,545.603l-.008-7.154c-.002-1.992,2.534-3.208,5.672-2.715l4.858,.763c3.16,.496,5.73,2.525,5.732,4.531l.01,7.204c.003,2.006-2.563,3.214-5.723,2.698l-4.859-.793c-3.139-.512-5.679-2.542-5.682-4.534Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.09,567.944h0c-1.614-.272-2.921-1.314-2.923-2.328l-.057-37.655c-.002-1.012,1.303-1.635,2.916-1.391h0c1.615,.245,2.927,1.266,2.929,2.281l.06,37.747c.002,1.016-1.308,1.618-2.924,1.345Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.79,549.542l-.011-7.228c-.003-2.013,2.585-3.237,5.789-2.734l4.96,.779c3.226,.507,5.85,2.561,5.853,4.588l.012,7.279c.003,2.027-2.616,3.243-5.842,2.716l-4.961-.809c-3.204-.523-5.798-2.578-5.801-4.591Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.148,572.173h0c-1.648-.278-2.983-1.333-2.985-2.357l-.069-38.051c-.002-1.023,1.33-1.651,2.977-1.401h0c1.649,.25,2.989,1.284,2.991,2.31l.072,38.145c.002,1.027-1.336,1.633-2.985,1.354Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.669,553.563l-.013-7.304c-.004-2.034,2.639-3.267,5.91-2.753l5.064,.795c3.294,.517,5.974,2.598,5.978,4.646l.014,7.356c.004,2.049-2.67,3.273-5.964,2.735l-5.065-.826c-3.272-.534-5.92-2.615-5.924-4.649Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.737,576.491h0c-1.683-.284-3.047-1.353-3.049-2.388l-.082-38.455c-.002-1.034,1.358-1.666,3.039-1.411h0c1.684,.255,3.053,1.302,3.055,2.339l.085,38.551c.002,1.038-1.363,1.648-3.048,1.364Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.073,557.669l-.015-7.382c-.004-2.055,2.694-3.297,6.034-2.772l5.172,.812c3.364,.528,6.102,2.636,6.106,4.706l.017,7.434c.005,2.07-2.726,3.303-6.09,2.754l-5.173-.844c-3.341-.545-6.047-2.653-6.051-4.708Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.219,607.401h0c-1.459-.284-2.641-1.297-2.641-2.261l-.004-35.844c0-.964,1.181-1.535,2.64-1.276h0c1.461,.259,2.646,1.253,2.646,2.219l.006,35.928c0,.967-1.186,1.52-2.647,1.235Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.732,589.752v-6.881c0-1.916,2.343-3.04,5.242-2.509l4.486,.822c2.917,.534,5.288,2.532,5.288,4.461l.002,6.927c0,1.929-2.37,3.045-5.287,2.492l-4.487-.849c-2.899-.549-5.243-2.546-5.244-4.462Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.872,611.815h0c-1.489-.29-2.694-1.315-2.695-2.289l-.014-36.202c0-.973,1.204-1.549,2.692-1.284h0c1.49,.265,2.7,1.27,2.7,2.246l.016,36.288c0,.977-1.209,1.533-2.7,1.242Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.231,593.976l-.002-6.95c0-1.935,2.39-3.066,5.346-2.525l4.576,.838c2.976,.545,5.394,2.567,5.395,4.515l.004,6.997c.001,1.949-2.416,3.071-5.393,2.507l-4.577-.866c-2.957-.56-5.349-2.581-5.349-4.517Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.981,616.318h0c-1.519-.296-2.749-1.333-2.75-2.318l-.024-36.568c0-.983,1.228-1.562,2.746-1.293h0c1.52,.27,2.754,1.288,2.755,2.274l.026,36.655c0,.987-1.233,1.546-2.754,1.249Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182,598.285l-.004-7.02c-.001-1.955,2.437-3.092,5.453-2.54l4.668,.855c3.036,.556,5.504,2.603,5.506,4.571l.006,7.068c.002,1.968-2.464,3.097-5.501,2.523l-4.669-.884c-3.016-.571-5.457-2.618-5.458-4.573Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.561,620.913h0c-1.55-.302-2.805-1.353-2.806-2.347l-.035-36.941c0-.993,1.253-1.576,2.802-1.301h0c1.551,.275,2.811,1.306,2.812,2.302l.037,37.03c.001,.997-1.258,1.559-2.81,1.257Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.597,602.68l-.006-7.092c-.002-1.975,2.486-3.119,5.563-2.556l4.764,.872c3.098,.567,5.617,2.64,5.62,4.628l.008,7.14c.002,1.989-2.514,3.124-5.613,2.538l-4.765-.902c-3.078-.582-5.569-2.655-5.57-4.63Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M157.624,625.603h0c-1.582-.308-2.864-1.372-2.865-2.377l-.046-37.322c-.001-1.004,1.278-1.59,2.859-1.309h0c1.583,.281,2.869,1.325,2.87,2.331l.048,37.413c.001,1.007-1.283,1.573-2.867,1.264Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.492,607.166l-.008-7.165c-.002-1.995,2.536-3.147,5.676-2.572l4.862,.89c3.162,.579,5.734,2.678,5.737,4.687l.01,7.214c.003,2.009-2.565,3.152-5.728,2.553l-4.863-.92c-3.141-.594-5.684-2.693-5.686-4.688Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.187,630.389h0c-1.615-.315-2.924-1.392-2.925-2.407l-.057-37.711c-.002-1.014,1.304-1.604,2.918-1.317h0c1.616,.287,2.929,1.344,2.931,2.36l.06,37.804c.002,1.017-1.31,1.586-2.927,1.271Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.881,611.745l-.011-7.239c-.003-2.016,2.587-3.175,5.793-2.587l4.964,.909c3.228,.591,5.854,2.717,5.858,4.747l.012,7.29c.003,2.03-2.618,3.179-5.846,2.568l-4.965-.939c-3.207-.607-5.803-2.732-5.806-4.748Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.265,635.276h0c-1.649-.321-2.985-1.413-2.987-2.439l-.069-38.108c-.002-1.025,1.331-1.618,2.979-1.326h0c1.65,.293,2.991,1.364,2.993,2.391l.072,38.203c.002,1.028-1.337,1.601-2.988,1.279Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.779,616.419l-.013-7.315c-.004-2.037,2.641-3.203,5.914-2.603l5.068,.928c3.296,.604,5.979,2.757,5.983,4.808l.014,7.367c.004,2.052-2.672,3.208-5.969,2.584l-5.069-.959c-3.274-.62-5.925-2.772-5.929-4.81Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.875,640.267h0c-1.684-.328-3.049-1.434-3.051-2.471l-.082-38.513c-.002-1.036,1.359-1.633,3.042-1.334h0c1.685,.299,3.055,1.384,3.057,2.422l.085,38.61c.002,1.039-1.365,1.615-3.051,1.286Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.203,621.192l-.015-7.393c-.004-2.058,2.696-3.232,6.039-2.62l5.176,.948c3.367,.617,6.107,2.798,6.111,4.871l.017,7.446c.005,2.074-2.728,3.237-6.095,2.6l-5.177-.98c-3.344-.633-6.051-2.814-6.056-4.873Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.227,666.836h0c-1.461-.323-2.643-1.367-2.643-2.333l-.004-35.895c0-.965,1.182-1.507,2.642-1.21h0c1.462,.298,2.648,1.324,2.648,2.291l.006,35.979c0,.968-1.187,1.491-2.649,1.168Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.735,648.968v-6.891c0-1.919,2.345-2.983,5.245-2.376l4.489,.939c2.919,.611,5.292,2.673,5.292,4.605l.002,6.937c0,1.932-2.371,2.987-5.291,2.358l-4.49-.967c-2.901-.625-5.247-2.686-5.247-4.605Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.897,671.846h0c-1.49-.329-2.696-1.387-2.697-2.363l-.014-36.254c0-.975,1.205-1.52,2.694-1.216h0c1.491,.304,2.701,1.342,2.702,2.319l.016,36.34c0,.978-1.21,1.503-2.702,1.174Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.251,653.783l-.002-6.96c0-1.938,2.391-3.008,5.35-2.389l4.579,.958c2.978,.623,5.398,2.711,5.399,4.662l.004,7.007c.001,1.951-2.418,3.012-5.396,2.371l-4.58-.986c-2.959-.637-5.352-2.724-5.353-4.663Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.023,676.958h0c-1.52-.336-2.751-1.407-2.752-2.392l-.024-36.621c0-.985,1.229-1.532,2.748-1.223h0c1.521,.31,2.756,1.361,2.757,2.348l.027,36.709c0,.988-1.234,1.516-2.756,1.179Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.218,658.695l-.004-7.03c-.001-1.957,2.439-3.033,5.457-2.402l4.672,.978c3.038,.636,5.508,2.75,5.51,4.721l.006,7.078c.002,1.971-2.466,3.037-5.505,2.383l-4.673-1.006c-3.019-.65-5.461-2.763-5.462-4.721Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.62,682.173h0c-1.551-.343-2.808-1.428-2.809-2.423l-.035-36.995c0-.995,1.254-1.546,2.804-1.23h0c1.552,.316,2.813,1.381,2.814,2.378l.037,37.085c.001,.998-1.259,1.529-2.812,1.185Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.651,663.706l-.006-7.102c-.002-1.977,2.487-3.059,5.567-2.415l4.767,.998c3.1,.649,5.622,2.79,5.624,4.781l.008,7.151c.002,1.991-2.516,3.063-5.617,2.395l-4.768-1.027c-3.08-.663-5.573-2.803-5.575-4.781Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M157.702,687.495h0c-1.583-.35-2.866-1.449-2.867-2.455l-.046-37.377c-.001-1.005,1.279-1.559,2.861-1.237h0c1.584,.323,2.871,1.401,2.873,2.409l.048,37.469c.001,1.008-1.284,1.542-2.869,1.191Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.564,668.82l-.008-7.175c-.002-1.998,2.538-3.085,5.681-2.428l4.866,1.018c3.165,.662,5.739,2.831,5.741,4.843l.01,7.225c.003,2.012-2.567,3.089-5.732,2.408l-4.867-1.048c-3.144-.677-5.688-2.845-5.691-4.843Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.284,692.928h0c-1.616-.357-2.926-1.47-2.927-2.487l-.057-37.767c-.002-1.016,1.305-1.572,2.92-1.243h0c1.617,.329,2.932,1.422,2.933,2.44l.06,37.86c.002,1.019-1.311,1.555-2.929,1.197Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.971,674.04l-.011-7.25c-.003-2.019,2.589-3.112,5.798-2.44l4.968,1.04c3.231,.676,5.859,2.873,5.862,4.906l.012,7.301c.003,2.033-2.62,3.116-5.851,2.42l-4.968-1.07c-3.209-.691-5.807-2.887-5.81-4.906Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.382,698.475h0c-1.65-.365-2.988-1.493-2.99-2.52l-.069-38.165c-.002-1.026,1.332-1.586,2.981-1.25h0c1.652,.336,2.994,1.443,2.996,2.472l.072,38.261c.002,1.03-1.338,1.568-2.99,1.203Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.889,679.369l-.013-7.326c-.004-2.04,2.643-3.139,5.919-2.453l5.072,1.061c3.299,.69,5.983,2.917,5.987,4.971l.014,7.378c.004,2.055-2.674,3.143-5.974,2.432l-5.073-1.093c-3.277-.706-5.93-2.931-5.933-4.971Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M233.012,704.14h0c-1.685-.372-3.052-1.516-3.054-2.554l-.082-38.572c-.002-1.037,1.36-1.6,3.044-1.257h0c1.687,.344,3.058,1.465,3.06,2.505l.085,38.669c.002,1.041-1.366,1.582-3.053,1.209Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.334,684.811l-.015-7.404c-.004-2.062,2.698-3.166,6.044-2.466l5.18,1.084c3.369,.705,6.112,2.961,6.116,5.038l.017,7.457c.005,2.077-2.73,3.171-6.1,2.445l-5.181-1.116c-3.347-.721-6.056-2.975-6.061-5.037Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.236,726.356h0c-1.462-.361-2.645-1.438-2.645-2.405l-.004-35.946c0-.967,1.183-1.478,2.644-1.142h0c1.463,.336,2.65,1.394,2.65,2.363l.006,36.03c0,.97-1.187,1.462-2.651,1.1Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.738,708.268v-6.901c0-1.921,2.347-2.926,5.249-2.243l4.493,1.058c2.921,.688,5.296,2.815,5.296,4.749l.002,6.947c0,1.935-2.373,2.93-5.295,2.224l-4.493-1.085c-2.903-.701-5.251-2.826-5.251-4.748Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.922,731.964h0c-1.491-.369-2.698-1.459-2.699-2.436l-.014-36.306c0-.976,1.206-1.49,2.696-1.148h0c1.492,.343,2.703,1.414,2.704,2.393l.016,36.392c0,.979-1.211,1.474-2.704,1.105Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.27,713.676l-.002-6.97c0-1.941,2.393-2.95,5.353-2.253l4.583,1.079c2.98,.702,5.402,2.856,5.403,4.809l.004,7.017c.001,1.954-2.42,2.953-5.4,2.234l-4.583-1.107c-2.961-.715-5.356-2.867-5.357-4.809Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.065,737.685h0c-1.521-.376-2.753-1.481-2.754-2.468l-.024-36.674c0-.986,1.23-1.503,2.75-1.153h0c1.522,.35,2.758,1.435,2.759,2.424l.027,36.762c0,.989-1.235,1.486-2.758,1.109Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.254,719.193l-.004-7.041c-.001-1.96,2.44-2.974,5.461-2.263l4.675,1.101c3.041,.716,5.512,2.897,5.514,4.871l.006,7.088c.002,1.974-2.468,2.978-5.509,2.243l-4.676-1.13c-3.021-.73-5.465-2.909-5.466-4.87Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.68,743.522h0c-1.552-.384-2.81-1.503-2.811-2.5l-.035-37.049c0-.996,1.254-1.515,2.806-1.159h0c1.553,.357,2.815,1.456,2.816,2.455l.037,37.139c.001,1-1.26,1.498-2.814,1.114Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.704,724.821l-.006-7.112c-.002-1.98,2.489-2.999,5.571-2.273l4.771,1.123c3.103,.73,5.626,2.941,5.628,4.935l.008,7.161c.002,1.994-2.518,3.002-5.621,2.253l-4.772-1.153c-3.083-.745-5.577-2.953-5.579-4.933Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M157.78,749.479h0c-1.584-.392-2.868-1.525-2.869-2.533l-.046-37.433c-.001-1.007,1.28-1.528,2.863-1.164h0c1.586,.364,2.874,1.478,2.875,2.487l.049,37.524c.001,1.01-1.285,1.51-2.872,1.118Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.635,730.566l-.008-7.186c-.002-2.001,2.54-3.024,5.685-2.283l4.87,1.146c3.167,.746,5.743,2.985,5.746,5l.01,7.236c.003,2.015-2.569,3.027-5.737,2.262l-4.871-1.176c-3.146-.76-5.693-2.997-5.695-4.998Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.381,755.561h0c-1.617-.4-2.928-1.549-2.93-2.567l-.057-37.824c-.002-1.017,1.306-1.541,2.923-1.169h0c1.619,.372,2.934,1.5,2.935,2.52l.06,37.917c.002,1.02-1.312,1.523-2.931,1.122Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062,736.429l-.011-7.261c-.003-2.022,2.591-3.049,5.803-2.293l4.971,1.17c3.233,.761,5.864,3.03,5.867,5.066l.012,7.312c.003,2.036-2.622,3.052-5.856,2.271l-4.972-1.201c-3.212-.776-5.812-3.043-5.815-5.065Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.499,761.77h0c-1.652-.408-2.99-1.573-2.992-2.601l-.069-38.223c-.002-1.028,1.333-1.554,2.984-1.174h0c1.653,.38,2.996,1.523,2.998,2.554l.072,38.318c.002,1.031-1.339,1.536-2.993,1.127Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,742.414l-.013-7.337c-.004-2.043,2.645-3.075,5.924-2.303l5.076,1.195c3.302,.777,5.988,3.077,5.992,5.134l.015,7.389c.004,2.058-2.676,3.078-5.978,2.28l-5.077-1.226c-3.28-.792-5.935-3.089-5.938-5.133Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M233.15,768.111h0c-1.687-.417-3.054-1.597-3.056-2.637l-.082-38.631c-.002-1.039,1.361-1.567,3.047-1.18h0c1.688,.388,3.06,1.547,3.063,2.588l.085,38.728c.002,1.042-1.367,1.548-3.056,1.131Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.465,748.527l-.015-7.415c-.004-2.065,2.7-3.101,6.049-2.312l5.185,1.221c3.372,.794,6.117,3.125,6.121,5.204l.017,7.469c.005,2.08-2.732,3.104-6.105,2.289l-5.186-1.253c-3.349-.809-6.061-3.138-6.066-5.203Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.244,785.961h0c-1.463-.4-2.647-1.509-2.647-2.478l-.004-35.997c0-.968,1.184-1.45,2.645-1.075h0c1.464,.375,2.652,1.465,2.652,2.436l.006,36.081c0,.971-1.188,1.433-2.653,1.033Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.742,767.651v-6.911c0-1.924,2.348-2.869,5.253-2.11l4.496,1.176c2.923,.765,5.299,2.957,5.3,4.894l.002,6.957c0,1.937-2.375,2.872-5.299,2.089l-4.497-1.204c-2.905-.778-5.255-2.967-5.255-4.892Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.947,792.168h0c-1.492-.408-2.7-1.531-2.701-2.51l-.014-36.358c0-.978,1.207-1.461,2.698-1.079h0c1.493,.382,2.705,1.487,2.706,2.467l.016,36.445c0,.981-1.212,1.444-2.706,1.036Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.289,773.654l-.002-6.98c0-1.943,2.395-2.892,5.357-2.117l4.586,1.2c2.982,.78,5.406,3,5.407,4.957l.004,7.027c.001,1.957-2.422,2.895-5.404,2.096l-4.587-1.228c-2.963-.793-5.36-3.011-5.361-4.955Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.107,798.5h0c-1.522-.416-2.755-1.554-2.756-2.543l-.024-36.727c0-.988,1.231-1.473,2.752-1.083h0c1.523,.39,2.76,1.509,2.761,2.499l.027,36.815c0,.991-1.236,1.456-2.76,1.039Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.29,779.778l-.004-7.051c-.001-1.963,2.442-2.915,5.465-2.124l4.679,1.224c3.043,.796,5.517,3.045,5.518,5.022l.006,7.099c.002,1.977-2.47,2.918-5.513,2.103l-4.68-1.253c-3.023-.809-5.469-3.056-5.47-5.02Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.739,804.961h0c-1.553-.425-2.812-1.578-2.813-2.577l-.035-37.104c0-.998,1.255-1.485,2.808-1.087h0c1.555,.398,2.817,1.532,2.818,2.532l.037,37.194c.001,1.001-1.261,1.467-2.816,1.042Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.758,786.026l-.006-7.123c-.002-1.983,2.491-2.938,5.575-2.131l4.775,1.249c3.105,.812,5.63,3.091,5.632,5.088l.008,7.172c.002,1.997-2.52,2.941-5.625,2.109l-4.776-1.279c-3.085-.826-5.581-3.102-5.583-5.086Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M157.858,811.555h0c-1.585-.433-2.87-1.602-2.871-2.611l-.046-37.488c-.001-1.008,1.281-1.497,2.866-1.091h0c1.587,.406,2.876,1.555,2.877,2.566l.049,37.58c.001,1.011-1.286,1.479-2.874,1.045Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.707,792.402l-.008-7.196c-.002-2.004,2.542-2.962,5.689-2.138l4.873,1.275c3.17,.829,5.747,3.139,5.75,5.156l.01,7.247c.003,2.018-2.571,2.964-5.741,2.116l-4.874-1.305c-3.149-.843-5.697-3.15-5.699-5.154Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.479,818.287h0c-1.619-.443-2.93-1.627-2.932-2.647l-.057-37.88c-.002-1.019,1.307-1.509,2.925-1.095h0c1.62,.415,2.936,1.579,2.938,2.6l.06,37.974c.002,1.022-1.313,1.491-2.933,1.048Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.153,798.91l-.011-7.272c-.003-2.025,2.593-2.986,5.807-2.145l4.975,1.302c3.236,.847,5.868,3.187,5.872,5.226l.012,7.323c.003,2.039-2.624,2.988-5.86,2.122l-4.976-1.332c-3.214-.861-5.816-3.198-5.819-5.224Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.617,825.16h0c-1.653-.452-2.993-1.653-2.994-2.683l-.07-38.281c-.002-1.029,1.334-1.521,2.986-1.098h0c1.654,.424,2.998,1.604,3,2.636l.072,38.376c.002,1.033-1.34,1.503-2.995,1.05Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.11,805.555l-.013-7.348c-.004-2.046,2.647-3.01,5.928-2.152l5.08,1.329c3.304,.865,5.993,3.237,5.997,5.298l.015,7.401c.004,2.061-2.678,3.013-5.983,2.128l-5.081-1.361c-3.282-.879-5.939-3.249-5.943-5.295Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M233.289,832.179h0c-1.688-.462-3.057-1.679-3.059-2.721l-.082-38.69c-.002-1.04,1.362-1.534,3.049-1.102h0c1.69,.433,3.063,1.629,3.065,2.672l.085,38.788c.002,1.044-1.368,1.515-3.058,1.053Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.596,812.34l-.015-7.427c-.004-2.068,2.702-3.035,6.054-2.158l5.189,1.358c3.375,.883,6.122,3.289,6.126,5.372l.017,7.48c.005,2.083-2.735,3.037-6.11,2.134l-5.19-1.39c-3.352-.898-6.066-3.3-6.071-5.369Z",
    fill: "#7f5640"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 266.018,
    y: 573.37,
    width: 172.46,
    height: 347.478,
    rx: 14.682,
    ry: 14.682,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.018,
    y: 575.37,
    width: 172.46,
    height: 347.478,
    rx: 14.682,
    ry: 14.682,
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.255,
    y: 590.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.254,
    y: 590.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(914.875 303.277) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 354.74,
    y: 590.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.74,
    y: 590.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(970.359 247.791) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 410.226,
    y: 590.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.225,
    y: 590.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1025.843 192.306) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.255,
    y: 646.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.254,
    y: 646.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(970.884 359.284) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 354.74,
    y: 646.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.74,
    y: 646.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1026.368 303.799) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 410.226,
    y: 646.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.225,
    y: 646.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1081.852 248.313) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.255,
    y: 702.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.254,
    y: 702.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1026.893 415.291) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 354.74,
    y: 702.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.74,
    y: 702.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1082.377 359.806) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 410.226,
    y: 702.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.225,
    y: 702.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1137.861 304.321) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.255,
    y: 758.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.254,
    y: 758.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1082.901 471.299) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 354.74,
    y: 758.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.74,
    y: 758.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1138.385 415.813) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 410.226,
    y: 758.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.225,
    y: 758.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1193.87 360.328) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.255,
    y: 814.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.254,
    y: 814.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1138.91 527.306) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 354.74,
    y: 814.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.74,
    y: 814.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1194.394 471.821) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 410.226,
    y: 814.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.225,
    y: 814.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1249.878 416.335) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.255,
    y: 870.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.254,
    y: 870.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1194.919 583.313) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 354.74,
    y: 870.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.74,
    y: 870.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1250.403 527.828) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 410.226,
    y: 870.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.225,
    y: 870.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1305.887 472.343) rotate(89.999)",
    fill: "#aa7552"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M424.697,606.897v4.99c0,1.04-.16,2.05-.46,2.99-1.27,4.06-5.05,7.01-9.54,7.01h-107.515c-4.49,0-8.27-2.95-9.54-7.01-.3-.94-.46-1.95-.46-2.99v-4.99h127.515Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.178,
    y: 600.09,
    width: 16.409,
    height: 16.752,
    rx: 8.204,
    ry: 8.204,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.294,
    y: 600.09,
    width: 16.409,
    height: 16.752,
    rx: 8.204,
    ry: 8.204,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.237,614.877c-1.27,4.06-5.05,7.01-9.54,7.01h-107.515c-4.49,0-8.27-2.95-9.54-7.01h126.595Z",
    fill: "#b0b0b0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M473.359,306.98l-213.159-.41V0l12.699,.024c1.56,.473,3.13,.936,4.699,1.349,23.895,6.326,49.055,1.834,73.615,3.782,8.58,.677,17.093,2.153,25.673,2.899,8.675,.747,17.407,.753,26.111,.76,11.348,.002,22.744,.004,33.93-1.905,7.144-1.216,14.364-3.222,21.526-2.079,2.73,.425,5.403,1.31,8.162,1.406,2.159,.064,4.452-.461,6.116-1.828l.628,302.571Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(280.444 225.822)",
    fontFamily: "Lato-Black, Lato",
    fontSize: 31
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".14em"
  }, "CRAF"), /*#__PURE__*/React.createElement("tspan", {
    x: 97.664,
    y: 0,
    letterSpacing: ".11em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 42,
    letterSpacing: ".114em"
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.769,
    y: 42,
    letterSpacing: ".14em"
  }, "VEN")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraftOven);
export default __webpack_public_path__ + "static/media/craft-oven.1f59963e8137566ba737e9d7117b2fcb.svg";
export { ForwardRef as ReactComponent };